import PropTypes from 'prop-types';

const reduxInputPropType = PropTypes.shape({
  checked: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onDragStart: PropTypes.func.isRequired,
  onDrop: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.object,
  ]).isRequired,
});

const reduxMetaPropType = PropTypes.shape({
  active: PropTypes.bool.isRequired,
  autofilled: PropTypes.bool.isRequired,
  asyncValidating: PropTypes.bool.isRequired,
  dirty: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  error: PropTypes.string,
  form: PropTypes.string.isRequired,
  initial: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.array,
    PropTypes.number,
    PropTypes.object,
  ]),
  invalid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  submitFailed: PropTypes.bool.isRequired,
  touched: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  visited: PropTypes.bool.isRequired,
  warning: PropTypes.string,
});

const paymentFormDataPropType = PropTypes.shape({
  addressLine1: PropTypes.string.isRequired,
  addressLine2: PropTypes.string,
  cardNumber: PropTypes.string.isRequired,
  cardType: PropTypes.number.isRequired,
  city: PropTypes.string.isRequired,
  expirationMonth: PropTypes.string.isRequired,
  expirationYear: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  securityCode: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  zipCode: PropTypes.string.isRequired,
});

const payPalButtonDataPropType = PropTypes.shape({
  intent: PropTypes.string.isRequired,
  orderID: PropTypes.string.isRequired,
  payerID: PropTypes.string.isRequired,
  paymentToken: PropTypes.string.isRequired,
  returnUrl: PropTypes.string.isRequired,
});

const courseFormat = PropTypes.shape({
  courseFormatType: PropTypes.string,
  name: PropTypes.string,
  sourceId: PropTypes.PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  type: PropTypes.PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
});

const cleSearchFiltersOptions = PropTypes.shape({
  courseFormatFilters: PropTypes.arrayOf(Object),
  locationFilters: PropTypes.arrayOf(Object),
  practiceAreaFilters: PropTypes.arrayOf(Object),
  creditHoursFilters: PropTypes.arrayOf(Object),
});

export {
  cleSearchFiltersOptions,
  courseFormat,
  reduxInputPropType,
  reduxMetaPropType,
  paymentFormDataPropType,
  payPalButtonDataPropType,
};
